import { IAppBooted } from "../../models/boot";
export const BootState: IAppBooted = {
  status: false,
  errors: [],
};
